import React, { useMemo } from 'react';

import styled from 'styled-components';

// constants
import aampeTheme from '../../../constants/aampeTheme';
import ICONS from '../../../constants/icons';

interface StyledProps {
    color?: string;
    backgroundColor?: string;
}

interface StepCircleProps {
    index: number;
    currentStepIndex: number;
    isCompleted?: boolean;
}

const AampeStepCircle: React.FC<React.PropsWithChildren<StepCircleProps>> = ({
    index,
    currentStepIndex,
    isCompleted,
}) => {
    const backgroundColor = useMemo<string>(() => {
        return currentStepIndex === index
            ? aampeTheme.colors.solidA01
            : isCompleted
            ? aampeTheme.colors.success
            : aampeTheme.colors.interactiveWG01;
    }, [index, currentStepIndex, isCompleted]);

    const textColor = useMemo<string>(() => {
        return currentStepIndex === index
            ? aampeTheme.colors.white
            : aampeTheme.colors.solidWG02;
    }, [index, currentStepIndex]);

    return (
        <Circle backgroundColor={backgroundColor}>
            {!isCompleted || currentStepIndex === index ? (
                <Text color={textColor}>{index + 1}</Text>
            ) : (
                <ICONS.check color={aampeTheme.colors.white} size={24} />
            )}
        </Circle>
    );
};

export default AampeStepCircle;

const Circle = styled.div.withConfig({
    shouldForwardProp: (prop) => !['backgroundColor'].includes(prop),
})<StyledProps>(({ backgroundColor }) => ({
    display: 'flex',
    borderRadius: '50%',
    height: '24px',
    width: '24px',
    border: `1px solid ${aampeTheme.colors.bordersWG01}`,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: backgroundColor,
}));

const Text = styled.span.withConfig({
    shouldForwardProp: (prop) => !['color'].includes(prop),
})<StyledProps>(({ color }) => ({
    fontSize: '16px',
    fontWeight: 600,
    lineHeight: '20px',
    color: color,
}));
